import { Key } from "@phosphor-icons/react";

const PROVIDERS = [
  { id: "openai", label: "OpenAI", hint: "sk-..." },
  { id: "anthropic", label: "Claude", hint: "sk-ant-..." },
  { id: "gemini", label: "Gemini", hint: "AIza..." },
];

export const ByokPanel = ({ provider, apiKey, setProvider, setApiKey }) => {
  const active = PROVIDERS.find((p) => p.id === provider);
  return (
    <div className="surface rounded-[20px] p-6 sm:p-8 mb-4">
      <p className="text-sm font-semibold flex items-center gap-2 mb-4"><Key size={16} color="var(--coral)" weight="duotone" /> Your AI key (BYOK)</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {PROVIDERS.map((p) => (
          <button
            key={p.id}
            data-testid={`provider-${p.id}`}
            onClick={() => setProvider(p.id)}
            className={`px-4 py-1.5 rounded-full text-sm transition-colors ${
              provider === p.id ? "bg-[var(--glow)] text-white" : "surface text-[var(--muted)] hover:text-[var(--text)]"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <input
        data-testid="byok-key-input"
        type="password"
        value={apiKey}
        onChange={(e) => setApiKey(e.target.value)}
        placeholder={`${active.label} API key (${active.hint})`}
        className="w-full bg-[var(--bg)] border border-[var(--border-c)] rounded-[14px] px-4 py-3 text-sm outline-none focus:border-[var(--glow)]"
      />
      <p className="text-xs text-[var(--muted)] mt-2">Stored in your browser only — never saved on our servers.</p>
    </div>
  );
};
